import React from "react";
import Admin from "./Admin/Admin.js";
import League from "./League/League.js";
//import RestrictedNFLTable from "./RestrictedNFLTable.js";
import Market from "./Market.js";
import AdminStock from "./Admin/AdminStock.js";
import AdminGame from "./Admin/AdminGame.js";
//import RestrictedTable from "./RestrictedTable.js";
import About from "./About.js";
import SiteNews from './SiteNews.js';
import CreatePortfolio from "./Portfolio/CreatePortfolio.js";
import AddPortToLeague from "./Portfolio/AddPortToLeague.js";
import PortfolioPage from "./Portfolio/PortfolioPage.js";
import MyPortfoliosPage from "./Portfolio/MyPortfoliosPage.js";
import CreateLeaguePage from "./League/CreateLeaguePage.js";
import JoinLeaguePage from "./League/JoinLeaguePage.js";
import MyLeaguePage from "./League/MyLeaguesPage.js";
import RestrictedTable from "./RestrictedTable.js";
import ProtectedRoute from "./RouterHelpers/ProtectedRoute.js";
import PublicOnlyRoute from "./RouterHelpers/PublicOnlyRoute.js";
import AdminRoute from "./RouterHelpers/AdminRoute.js";

import './App.css';
import AdminPost from "./Admin/AdminPost.js";
import AdminEmail from "./Admin/AdminEmail.js";

import { Routes, Route } from "react-router-dom";
import MarketNotFound from "./RouterHelpers/MarketNotFound.js";
import PageNotFound from "./RouterHelpers/PageNotFound.js";
import SignUpPage from "./SignUpPage.js";
import LogInPage from "./LogInPage.js";
import ForgotPasswordPage from "./ForgotPasswordPage.js";
import ResetPasswordPage from "./ResetPasswordPage.js";
import { currentMLBtimeframe, currentNCAAMtimeframe, currentNFLPlayoffstimeframe, currentNFLtimeframe } from "./CONSTANTS.js";
import Blog from "./Blog.js";
import UserPortsSidebar from "./UserPortsSidebar.js";
import { useMediaQuery } from "react-responsive";

const Body = (props) => {

  const isTabletOrMobile = useMediaQuery({maxWidth:1024});

  return (
    <div>
      <div class="column side">
          <SiteNews />
      </div>
      <div class="column middle">
      <Routes>
            {/* Public Routes */}
            <Route path="/" element={<About />} />
            <Route path="/home" element={<About/>} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />

            {/* Auth Routes - Only accessible when NOT logged in */}
            <Route element={<PublicOnlyRoute />}>
              <Route path="/signup" element={<SignUpPage />} />
              <Route path="/signup/:redirectUrl?" element={<SignUpPage />} />
              <Route path="/login" element={<LogInPage />} />
              <Route path="/login/:redirectUrl?" element={<LogInPage />} />
              <Route path="/forgotpassword" element={<ForgotPasswordPage />} />
              <Route path="/forgotpassword/:redirectUrl?" element={<ForgotPasswordPage />} />
              <Route path="/resetpassword" element={<ResetPasswordPage />} />
              <Route path="/resetpassword/:redirectUrl?" element={<ResetPasswordPage />} />
            </Route>

            {/* Market Routes */}
            <Route path="/market">
              <Route index element={<Market hist={false} transact={0} year={2026} timeframe={currentNFLtimeframe} type="Reg" sport="NFL" />} />
              <Route path="NFL">
                <Route index element={<Market year={2025} timeframe={currentNFLtimeframe} hist={false} type="Reg" sport="NFL" transact={0}/>} />
                <Route path="2026" element={<Market year={2026} timeframe={16} hist={false} type="Reg" sport="NFL" transact={0}/>} />
                <Route path="2025" element={<Market year={2025} timeframe={11} hist={true} type="Reg" sport="NFL" transact={0}/>} />
                <Route path="2024" element={<Market year={2024} timeframe={7} hist={true} type="Reg" sport="NFL" transact={0}/>} />
                <Route path="2023" element={<Market year={2023} timeframe={3} hist={true} type="Reg" sport="NFL" transact={0}/>} />
                <Route path="*" element={<MarketNotFound />} />
              </Route>
              <Route path="NFLPlayoffs">
                <Route index element={<Market year={2025} hist={false} timeframe={currentNFLPlayoffstimeframe} type="Playoffs" sport="NFL" transact={0}/>} />
                <Route path="2025" element={<Market year={2025} timeframe={12} hist={true} type="Playoffs" sport="NFL" transact={0}/>} />
                <Route path="2024" element={<Market year={2024} timeframe={8} hist={true} type="Playoffs" sport="NFL" transact={0}/>} />
                <Route path="2023" element={<Market year={2023} timeframe={4} hist={true} type="Playoffs" sport="NFL" transact={0}/>} />
                <Route path="*" element={<MarketNotFound />} />
              </Route>
              <Route path="MLB">
                <Route index element={<Market year={2026} hist={false} timeframe={currentMLBtimeframe} type="Reg" sport="MLB" transact={0}/>} />
                <Route path="2026" element={<Market year={2026} timeframe={15} hist={false} type="Reg" sport="MLB" transact={0}/>} />
              </Route>
              <Route path="NCAAM">
                <Route index element={<Market year={2026} hist={false} timeframe={currentNCAAMtimeframe} type="Playoffs" sport="NCAAM" transact={0}/>} />
                <Route path="2026" element={<Market year={2026} timeframe={14} hist={false} type="Playoffs" sport="NCAAM" transact={0}/>} />
                <Route path="2025" element={<Market year={2025} timeframe={10} hist={true} type="Playoffs" sport="NCAAM" transact={0}/>} />
                <Route path="2024" element={<Market year={2024} timeframe={6} hist={true} type="Playoffs" sport="NCAAM" transact={0}/>} />
                <Route path="*" element={<MarketNotFound />} />
              </Route>
              {<Route path="restricted" element={<RestrictedTable type="Reg" sport="NFL" />} />}
              {/*<Route path="restricted" element={<RestrictedTable type="Playoffs" sport="NFL" />} /> */}
              {/*<Route path="restricted" element={<RestrictedTable type="Playoffs" sport="NCAAM" />} />*/}
              <Route path="*" element={<MarketNotFound />} />
            </Route>

            {/* Protected Routes - Only accessible when logged in */}
            <Route element={<ProtectedRoute />}>
              {/* Portfolio Routes */}
              <Route path="/portfolio">
                <Route path="create" element={<CreatePortfolio />} />
                <Route path="add" element={<AddPortToLeague />} />
                <Route path=":id" element={<PortfolioPage />} />
                <Route path="*" element={<PageNotFound />} />
              </Route>
              <Route path="/portfolios" element={<MyPortfoliosPage />} />

              {/* League Routes */}
              <Route path="/league">
                <Route path="create" element={<CreateLeaguePage />} />
                <Route path="join/:id" element={<JoinLeaguePage />} />
                <Route path="join" element={<JoinLeaguePage />} />
                <Route path=":id" element={<League />} />
                <Route path="*" element={<PageNotFound />} />
              </Route>
              <Route path="/leagues" element={<MyLeaguePage />} />

              {/* Admin Routes - Only accessible when logged in AND admin */}
              <Route element={<AdminRoute />}>
                <Route path="/admin">
                  <Route index element={<Admin />} />
                  <Route path="universal" element={<Admin />} />
                  <Route path="stock" element={<AdminStock />} />
                  <Route path="post" element={<AdminPost />} />
                  <Route path="email" element={<AdminEmail />} />
                  <Route path="game" element={<AdminGame />} />
                  <Route path="*" element={<PageNotFound />} />
                </Route>
              </Route>
            </Route>

            {/* Catch-all route for any unmatched paths */}
            <Route path="*" element={<PageNotFound />} />
          </Routes>
      </div>
      <div class="column side">
        {!isTabletOrMobile && <UserPortsSidebar /> }
      </div>
    </div>
  );
}

export default Body;
